export const adminNavbarConfig = [
  {
    name: 'Banner',
    icon: <i data-feather="image"></i>,
    path: '/admin/banner'
  },
  {
    name: 'User',
    icon: <i data-feather="users"></i>,
    children: [
      { name: 'Real', path: '/admin/user' },
      { name: 'Fake', path: '/admin/fakeUser' },
      { name: 'Live', path: '/admin/liveuser' }
    ]
  },
  {
    name: 'Agency',
    icon: <i data-feather="image"></i>,
    children: [
      { name: 'Agency', path: '/admin/agency' },
      { name: 'Agency History', path: '/admin/agencyHistory' },
      { name: 'Agency Redeem', path: '/admin/agencyRedeemRequest' }
    ]
  },
  {
    name: 'Host Request',
    icon: <i data-feather="user-check"></i>,
    path: '/admin/hostRequest'
  },
  {
    name: 'Coin Seller',
    icon: <i data-feather="dollar-sign"></i>,
    path: '/admin/coinSeller'
  },
  {
    name: 'User Redeem',
    icon: <i data-feather="key"></i>,
    path: '/admin/userRedeemRequest'
  },
  {
    name: 'Plan',
    icon: <i data-feather="layout"></i>,
    path: '/admin/mainPlan'
  },
  {
    name: 'Badges',
    icon: <i data-feather="layout"></i>,
    path: '/admin/badge'
  },
  {
    name: 'Country',
    icon: <i data-feather="layout"></i>,
    path: '/admin/country'
  },
  {
    name: 'Tags',
    icon: <i data-feather="layout"></i>,
    path: '/admin/tags'
  },
  {
    name: 'Plan History',
    icon: <i data-feather="clock"></i>,
    path: '/admin/planHistory'
  },
  {
    name: 'Game',
    icon: <i className="far fa-gamepad" style={{ fontSize: '23px' }}></i>,
    path: '/admin/game'
  },
  {
    name: 'Game History',
    icon: <i data-feather="hash"></i>,
    path: '/admin/gameHistory'
  },
  {
    name: 'Gift',
    icon: <i data-feather="gift"></i>,
    children: [
      {
        name: 'Category',
        path: '/admin/giftCategory',
      },
      {
        name: 'Gift',
        path: '/admin/gift',
      }
    ]
  },
  {
    name: 'Reaction',
    icon: <i className="far fa-smile-wink" style={{ fontSize: '23px' }}></i>,
    path: '/admin/reaction'
  },
  {
    name: 'Store',
    icon: <i data-feather="loader"></i>,
    children: [
      { name: 'Entry Effect', path: '/admin/entryEffect' },
      { name: 'Avatar Frame', path: '/admin/avatarFrame' }
    ]
  },
  {
    name: 'Theme',
    icon: <i data-feather="image"></i>,
    path: '/admin/theme'
  },
  {
    name: 'Song',
    icon: <i data-feather="music"></i>,
    path: '/admin/song'
  },
  {
    name: 'Hashtag',
    icon: <i data-feather="hash"></i>,
    path: '/admin/hashtag'
  },
  {
    name: 'Level',
    icon: <i data-feather="bar-chart"></i>,
    path: '/admin/level'
  },
  {
    name: 'Post',
    icon: <i data-feather="maximize"></i>,
    path: '/admin/mainPost'
  },
  {
    name: 'Video',
    icon: <i data-feather="film"></i>,
    path: '/admin/mainVideo'
  },
  {
    name: 'Reported User',
    icon: <i data-feather="flag"></i>,
    path: '/admin/reportedUser'
  },
  {
    name: 'Complain Request',
    icon: <i data-feather="help-circle"></i>,
    path: '/admin/complainRequest'
  },
  {
    name: 'Google Ad',
    icon: <i data-feather="book"></i>,
    path: '/admin/advertisement'
  },
  {
    name: 'Setting',
    icon: <i data-feather="settings"></i>,
    path: '/admin/setting'
  },
  {
    name: 'Access Role',
    icon: <i data-feather="shield"></i>,
    path: '/admin/role'
  },
  {
    name: 'Staff',
    icon: <i data-feather="users"></i>,
    path: '/admin/staff'
  },
  {
    name: 'Audit History',
    icon: <i data-feather="file-text"></i>,
    path: '/admin/auditHistory'
  },
];

export const adminModulesConfigForRole = (() => {
  const sections = [];
  const uniqueModules = [];
  adminNavbarConfig.forEach((item) => {
    const section = item.name;
    if (!sections.includes(section)) sections.push(section);
    if (item.children) {
      (item.children || []).forEach((child) => {
        const path = child.path || '';
        const key = path.replace(/^\//, '');
        if (key) {
          uniqueModules.push({
            key,
            name: child.name,
            section,
            icon: item.icon,
          });
        }
      });
    } else {
      const path = item.path || '';
      const key = path.replace(/^\//, '');
      if (key) {
        uniqueModules.push({
          key,
          name: item.name,
          section,
          icon: item.icon,
        });
      }
    }
  });
  return { sections, uniqueModules };
})();
